var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "banner_service_inner" },
    [
      _c("el-image", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { src: _vm.value.config.image },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }